import script from "./UpdateInfoDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./UpdateInfoDialog.vue?vue&type=script&setup=true&lang=js"

import "./UpdateInfoDialog.vue?vue&type=style&index=0&id=5ef5112e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ef5112e"]])

export default __exports__